var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00016 0 80 0 80 80 0.00016 80"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hifi",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18.-Conirmation-Message-1",
    transform: "translate(-360.000000, -179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(250.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(110.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#979797",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    cx: 40,
    cy: 40,
    r: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.00016,3.19944 C19.67616,3.19944 3.20016,19.67544 3.20016,39.99944 C3.19936,60.32344 19.67616,76.80024 40.00016,76.80024 C60.32416,76.80024 76.80016,60.32424 76.80016,39.99944 C76.77776,19.68504 60.31536,3.22264 40.00016,3.19944 M40.00016,80.00024 C17.90896,80.00024 0.00016,62.09144 0.00016,39.99944 C0.00016,17.90824 17.90816,-0.00056 40.00016,-0.00056 C62.09136,-0.00056 80.00016,17.90824 80.00016,39.99944 C79.97536,62.08104 62.08176,79.97464 40.00016,80.00024",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.4252,45.74824 C56.8852,45.13144 55.9676,45.02184 55.298,45.49464 C50.8124,48.64904 45.4828,50.38344 40.0004,50.47224 C34.5172,50.38344 29.1876,48.64904 24.7028,45.49464 C24.0332,45.02184 23.1148,45.13144 22.5756,45.74824 C21.99,46.41064 22.0524,47.42184 22.7148,48.00664 C22.7564,48.04344 22.7996,48.07784 22.8444,48.10984 C27.8652,51.66344 33.8492,53.60424 40.0004,53.67224 C46.1508,53.60424 52.1356,51.66344 57.1556,48.10984 C57.8748,47.59624 58.042,46.59704 57.5284,45.87784 C57.4964,45.83304 57.462,45.78984 57.4252,45.74824",
    id: "Fill-4",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32992,32.1928 L33.32992,32.1928 C32.60192,32.188 31.96832,31.6944 31.78512,30.9896 C31.12032,28.5416 28.59792,27.096 26.14992,27.76 C24.57632,28.1872 23.34672,29.416 22.92032,30.9896 C22.73712,31.6944 22.10352,32.188 21.37552,32.1928 L21.37552,32.1928 C20.48592,32.188 19.76832,31.4632 19.7730961,30.5736 C19.77392,30.4288 19.79392,30.284 19.83312,30.1448 C20.96432,25.992 25.24832,23.5424 29.40112,24.6736 C32.06512,25.3992 34.14672,27.4808 34.87152,30.1448 C35.11312,31.0008 34.61472,31.8912 33.75872,32.132 C33.61952,32.172 33.47472,32.192 33.32992,32.1928",
    id: "Fill-6",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62672,32.1928 L58.62672,32.1928 C57.89872,32.188 57.26512,31.6944 57.08192,30.9896 C56.41712,28.5416 53.89472,27.096 51.44672,27.76 C49.87392,28.1872 48.64352,29.416 48.21712,30.9896 C48.03472,31.6944 47.40032,32.188 46.67232,32.1928 C45.78272,32.188 45.06512,31.4632 45.0698961,30.5736 C45.07072,30.4288 45.09072,30.284 45.13072,30.1448 C46.26192,25.992 50.54512,23.5424 54.69792,24.6736 C57.36192,25.3992 59.44352,27.4808 60.16912,30.1448 C60.40992,31.0008 59.91152,31.8912 59.05552,32.132 C58.91552,32.172 58.77232,32.192 58.62672,32.1928",
    id: "Fill-8",
    fill: "#000000"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.321fad496c5b70d65ac5c4efe90153b2.svg";
export { ForwardRef as ReactComponent };